import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { TaFormlyFieldWrapperModule } from '@ta-formly/ta-field-wrapper/ta-field-wrapper.module';
import { TaPassFailComponent } from './ta-pass-fail.type';

@NgModule({
    declarations: [TaPassFailComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IonicModule,

        TaFormlyFieldWrapperModule,
        FormlySelectModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-pass-fail',
                    component: TaPassFailComponent,
                    wrappers: ['ta-field-wrapper']
                }
            ]
        })
    ]
})
export class TaFormlyPassFailModule { }
